import {
  ApiResponse,
  CreateOfferingTransactionReviewRequest,
  OfferingTransactionId,
  OfferingTransactionReview,
  UpdateOfferingTransactionReviewRequest,
} from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const postCreateOfferingTransactionReview = async (request: CreateOfferingTransactionReviewRequest) => {
  const response = await api.post<ApiResponse<OfferingTransactionReview>>(
    `/trades/${request.offeringTransactionId}/review`,
    request
  );

  return unwrapApiResponse(response.data);
};

export const getOfferingTransactionReview = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.get<ApiResponse<OfferingTransactionReview>>(`/trades/${offeringTransactionId}/review`);

  return unwrapApiResponse(response.data);
};

export const patchUpdateOfferingTransactionReview = async (request: UpdateOfferingTransactionReviewRequest) => {
  const response = await api.patch<ApiResponse<OfferingTransactionReview>>(
    `/trades/${request.offeringTransactionId}/review`,
    request
  );

  return unwrapApiResponse(response.data);
};

export const deleteOfferingTransactionReview = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.delete<ApiResponse<OfferingTransactionReview>>(`/trades/${offeringTransactionId}/review`);

  return unwrapApiResponse(response.data);
};
